export interface IStoreAdapter {
  get<R = unknown>(key: string): (R extends undefined ? never : R) | null;
  set(key: string, val: unknown): void;
  del(key: string): void;
  get size(): number;
  has(key: string): boolean;
  keys(): Array<string>;
}

export class Storage<
    KV extends Record<string, unknown[]>,
    K extends keyof KV = keyof KV
  >
  implements IStoreAdapter
{
  protected adapter = {} as IStoreAdapter;

  constructor(public scope = "DEF") {}

  scoped(key: string): string {
    return `${this.scope}|${key}`;
  }

  setAdapter(adapter: IStoreAdapter): void {
    this.adapter = adapter;
  }

  get<R = KV[K]>(key: string): (R extends undefined ? never : R) | null {
    return this.adapter.get(this.scoped(key));
  }

  set(key: string, val: unknown): void {
    this.adapter.set(this.scoped(key), val);
  }

  del(key: string): void {
    this.adapter.del(this.scoped(key));
  }

  get size(): number {
    return this.adapter.keys().length;
  }

  has(key: string): boolean {
    return this.adapter.has(this.scoped(key));
  }

  keys(): Array<string> {
    return this.adapter.keys().filter((key) => key.startsWith(this.scope));
  }
}

export const storage = new Storage();
